import React from "react";
import Skeleton from "@/app/_partials/_skeleton/Skeleton";

export default function FooterSkeleton() {
    return (
        <>
            {/* Desktop Footer Skeleton */}
            <div className="row gy-5 main-footer-wrapper d-none d-lg-flex">
                <div className="col-lg-2 col-sm-4">
                    <FooterSectionSkeleton items={4} />
                </div>
                <div className="col-xl-2 col-lg-3 col-sm-4">
                    <FooterSectionSkeleton items={6} />
                </div>
                <div className="col-lg-3 col-sm-4">
                    <div className="footer-item-wrapper">
                        <FooterSectionSkeleton items={2} />
                        <FooterSectionSkeleton items={3} />
                    </div>
                </div>
                <div className="col-lg-2 col-md-4 col-sm-8">
                    <FooterSectionSkeleton items={5} />
                </div>
                <div className="col-lg-2 col-sm-4">
                    <FooterHelpSkeleton />
                </div>
            </div>

            {/* Mobile Footer Skeleton */}
            <div className="row gy-5 main-footer-wrapper two d-lg-none d-flex">
                <div className="col-3">
                    <FooterSectionSkeleton items={4} />
                </div>
                <div className="col-6 col-md-5">
                    <FooterSectionSkeleton items={4} />
                </div>
                <div className="col-3 col-md-4">
                    <FooterSectionSkeleton items={2} />
                </div>
                <div className="col-3">
                    <FooterHelpSkeleton />
                </div>
                <div className="col-6 col-md-5">
                    <FooterSectionSkeleton items={3} />
                </div>
                <div className="col-3 col-md-4">
                    <FooterSectionSkeleton items={5} />
                </div>
            </div>
        </>
    );
}

function FooterSectionSkeleton({ items }) {
    return (
        <div className="footer-item">
            <Skeleton height={20} width="50%" borderRadius={5} className="mb-3" baseColor="rgba(255,255,255,0.1)"/>
            <ul className="footer-menu">
                {Array.from({ length: items }).map((_, idx) => (
                    <li key={idx} className="footer-menu__item mb-2">
                        <Skeleton height={14} width="80%" borderRadius={4} baseColor="rgba(255,255,255,0.1)"/>
                    </li>
                ))}
            </ul>
        </div>
    );
}

function FooterHelpSkeleton() {
    return (
        <div className="footer-item help">
            <Skeleton height={20} width="50%" borderRadius={5} className="mb-3" baseColor="rgba(255,255,255,0.1)"/>
            <ul className="footer-menu">
                {[...Array(3)].map((_, idx) => (
                    <li key={idx} className="footer-menu__item mb-2 d-flex align-items-center">
                        <Skeleton height={16} width={16} borderRadius="50%" className="me-2" baseColor="rgba(255,255,255,0.1)"/>
                        <Skeleton height={14} width="70%" borderRadius={4} baseColor="rgba(255,255,255,0.1)"/>
                    </li>
                ))}
            </ul>
        </div>
    );
}
